import {AuthModel} from './_models';
import {logout} from './_requests';

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v';
const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return;
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
  if (!lsValue) {
    return;
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel;
    if (auth) {
      // You can easily check auth_token expiration also
      return auth;
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error);
  }
};

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return;
  }

  try {
    const lsValue = JSON.stringify(auth);
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue);
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error);
  }
};

const removeAuth = () => {
  if (!localStorage) {
    return;
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error);
  }
};

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json';

  axios.interceptors.request.use(
    (config: {headers: {Authorization: string}}) => {
      const auth = getAuth();
      if (auth && auth.api_token) {
        config.headers.Authorization = `Bearer ${auth.api_token}`;
      }

      return config;
    },
    (err: any) => Promise.reject(err)
  );

  axios.interceptors.response.use(
    (response: any) => {
      return response;
    },
    (error: any) => {
      console.log('axios response error', error);

      const originalRequest = error.config;
      // const url: string = originalRequest.url;
      const path = window.location.pathname;

      if (error.response?.status === 401 && !path.includes('/auth')) {
        const auth = getAuth();
        if (auth) {
          removeAuth();
          logout(auth.api_token);
        }
        window.open('/auth/login', '_self');

        return Promise.reject(error);
      }
      return Promise.reject(error);

      // //[!!] this code to refresh token if it has been expired
      //
      // if (error.response.status === 401 && !originalRequest._retry) {
      //   originalRequest._retry = true
      //   const refreshToken = localStorageService.getRefreshToken()
      //   return axios
      //     .post('/auth/token', {
      //       refresh_token: refreshToken
      //     })
      //     .then(res => {
      //       if (res.status === 201) {
      //         localStorageService.setToken(res.data)
      //         axios.defaults.headers.common['Authorization'] =
      //           'Bearer ' + localStorageService.getAccessToken()
      //         return axios(originalRequest)
      //       }
      //     })
      // }
      // return Promise.reject(error)
      // // [!!]
    }
  );
}

export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY};
